// src/components/Comingsoon.jsx
import React, { useEffect, useState } from 'react';

const Comingsoon = () => {
  // Calculate target date 30 days from now (once)
  const targetDate = new Date();
  targetDate.setDate(targetDate.getDate() + 31);

  const calculateTimeLeft = () => {
    const now = new Date();
    const diff = targetDate - now;

    return {
      days: Math.max(0, Math.floor(diff / (1000 * 60 * 60 * 24))),
      hours: Math.max(0, Math.floor((diff / (1000 * 60 * 60)) % 24)),
      minutes: Math.max(0, Math.floor((diff / 1000 / 60) % 60)),
      seconds: Math.max(0, Math.floor((diff / 1000) % 60)),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="coming-soon-wrapper">
      <div className="overlay" />

      <div className="coming-soon-content text-center">
        <p className="pre-title">Our new page is</p>
        <h1 className="main-title">COMING SOON</h1>

        {/* TIMER is commented out */}

        <p className="sub-title mt-4">Stay tuned!</p>

        {/* App availability text */}
        <p className="app-coming-soon mt-2">iOS & Android apps coming soon</p>

        {/* QR Code Instruction */}
        <p className="qr-instruction mt-3">Scan the QR code to start your locker booking</p>

        {/* QR Code image */}
        <img
          src="../assets/qr.jpg"
          alt="QR Code to book locker"
          height="100"
          width="100"
          className="qr-image mt-2"
        />

        {/* Scroll Indicator */}
        <div className="scroll-indicator mt-4">
          <i className="fa fa-angle-double-down"></i>
        </div>
      </div>
    </div>
  );
};

export default Comingsoon;